import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

interface UploadIconProps extends Omit<SvgIconProps, "viewBox"> {
}

export const UploadIcon: FunctionComponent<UploadIconProps> = (props) => {
	return (
		<SvgIcon
			viewBox="0 0 16 16"
			{...props}
		>
			<path
				clipRule="evenodd"
				d="M5.99967 10.6667H9.99967V6.66667H12.6663L7.99967 2L3.33301 6.66667H5.99967V10.6667ZM3.33301 12H12.6663V13.3333H3.33301V12Z"
				fill="#79818F"
				fillRule="evenodd"
			/>
		</SvgIcon>
	);
};

export default UploadIcon;

